import type { StatCardProps } from "@/components/molecules/StatCard";
import { Lifebuoy } from "iconsax-react";

export interface SupportTicket {
  id: string;
  ticketID: string;
  user: string;
  category: string;
  assignedTo: string;
  priority: "Low" | "Medium" | "High";
  dateReported: string;
  status: "Open" | "In Progress" | "Resolved";
}

export interface UserFeedback {
  id: string;
  feedbackID: string;
  user: string;
  summary: string;
  type: string;
  upvotes: number;
  dateReported: string;
  status: "Planned" | "Under Review" | "Addressed";
}

export interface EmailFeedback {
  id: string;
  emailID: string;
  sender: string;
  subject: string;
  date: string;
  status: "New" | "Replied";
}

export const SUPPORT_STATS: StatCardProps[] = [
  {
    title: "Open Tickets",
    value: "45",
    icon: <Lifebuoy variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Resolved This Week",
    value: "88",
    icon: <Lifebuoy variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Feedback Received",
    value: "300",
    icon: <Lifebuoy variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Emails Received",
    value: "75",
    icon: <Lifebuoy variant="Bold" color="#484848" className="w-6 h-6" />,
  },
];

export const MOCK_SUPPORT_TICKETS: SupportTicket[] = [
  {
    id: "1",
    ticketID: "TKT201",
    user: "John Doe",
    category: "Payment",
    assignedTo: "Anna@gmail.com",
    priority: "High",
    dateReported: "2 Mar 2025",
    status: "Open",
  },
  {
    id: "2",
    ticketID: "TKT202",
    user: "John Smith",
    category: "Bug Report",
    assignedTo: "Anna@gmail.com",
    priority: "High",
    dateReported: "2 Mar 2025",
    status: "Open",
  },
  {
    id: "3",
    ticketID: "TKT201",
    user: "John Doe",
    category: "Payment",
    assignedTo: "Anna@gmail.com",
    priority: "Medium",
    dateReported: "2 Mar 2025",
    status: "In Progress",
  },
  {
    id: "4",
    ticketID: "TKT201",
    user: "John Doe",
    category: "Payment",
    assignedTo: "Anna@gmail.com",
    priority: "High",
    dateReported: "2 Mar 2025",
    status: "Open",
  },
];

export const MOCK_USER_FEEDBACKS: UserFeedback[] = [
  {
    id: "1",
    feedbackID: "FB103",
    user: "Sarah K.",
    summary: "“Add group filters...”",
    type: "Feature Request",
    upvotes: 120,
    dateReported: "2 Mar 2025",
    status: "Planned",
  },
  {
    id: "2",
    feedbackID: "FB104",
    user: "Alex P.",
    summary: "Suggestion",
    type: "“Dark mode option...”",
    upvotes: 120,
    dateReported: "2 Mar 2025",
    status: "Under Review",
  },
];

export const MOCK_EMAIL_FEEDBACKS: EmailFeedback[] = [
  {
    id: "1",
    emailID: "EML201",
    sender: "John Smith",
    subject: "Payment Issue",
    date: "2 Mar 2025",
    status: "Replied",
  },
  {
    id: "2",
    emailID: "EML202",
    sender: "Sarah Johnson",
    subject: "App Suggestion",
    date: "2 Mar 2025",
    status: "New",
  },
];

export const SUPPORTTICKET_TABLE_HEADERS = [
  "Ticket ID",
  "User",
  "Category",
  "Assigned To",
  "Priority",
  "Date Reported",
  "Status",
  "",
];

export const USERFEEDBACK_TABLE_HEADERS = [
  "Feedback ID",
  "User",
  "Summary",
  "Type",
  "Upvotes",
  "Date Reported",
  "Status",
  "",
];

export const EMAILFEEDBACK_TABLE_HEADERS = [
  "Email ID",
  "Sender",
  "Subject",
  "Date",
  "Status",
  "",
];
